import { gql } from "gql";

export const DYNAMIC_PROCESS_INITIATOR_NOTIFICATION =
  "DYNAMIC_PROCESS_INITIATOR_NOTIFICATION";
export const DYNAMIC_PROCESS_APPROVER_NOTIFICATION =
  "DYNAMIC_PROCESS_APPROVER_NOTIFICATION";

export type Code =
  | typeof DYNAMIC_PROCESS_INITIATOR_NOTIFICATION
  | typeof DYNAMIC_PROCESS_APPROVER_NOTIFICATION;

export const GET_NOTIFICATION_TEMPLATE_PROPERTIES_BY_CODE = gql(/* GraphQL */ `
  query GetNotificationPropertiesByCode($code: String!) {
    getNotificationPropertiesByCode(code: $code)
  }
`);
